var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Banner',{attrs:{"color":"info","label":_vm.t('podSecurityAdmission.banner.modifications')}}),_vm._v(" "),_c('ResourceTable',{attrs:{"loading":_vm.loading,"schema":_vm.schema,"rows":_vm.rows}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }